import React, { useEffect, useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Alert,
  CircularProgress,
} from '@mui/material';
import { useAuthStore } from '@store/authStore';
import PlayerCertificates from '@components/certificates/PlayerCertificates';
import { loadPlayerProfileForUser, buildFallbackPlayerProfile } from '@utils/coachPlayerProfile';

const CoachCertificatesPage: React.FC = () => {
  const { user } = useAuthStore();
  const [playerProfile, setPlayerProfile] = useState<any | null>(null);
  const [loadingPlayer, setLoadingPlayer] = useState(false);

  useEffect(() => {
    const loadPlayerProfile = async () => {
      if (!user?.id) return;
      setLoadingPlayer(true);
      try {
        const token = localStorage.getItem('accessToken') || localStorage.getItem('token');
        const profile = await loadPlayerProfileForUser(user.id, token, true, user);
        if (profile) {
          setPlayerProfile({
            ...profile,
            userId: profile.userId || user.id,
            user: {
              id: profile.userId || user.id,
              firstName: profile.firstName ?? profile.user?.firstName,
              lastName: profile.lastName ?? profile.user?.lastName,
              email: profile.email ?? profile.user?.email ?? user.email,
              role: profile.role ?? profile.user?.role ?? user.role,
              isActive: profile.isActive ?? profile.user?.isActive ?? true,
            },
          });
        } else {
          setPlayerProfile(buildFallbackPlayerProfile(user));
        }
      } catch (e) {
        console.error('Error loading coach player profile for certificates:', e);
        if (user) {
          setPlayerProfile(buildFallbackPlayerProfile(user));
        } else {
          setPlayerProfile(null);
        }
      } finally {
        setLoadingPlayer(false);
      }
    };
    loadPlayerProfile();
  }, [user?.id]);

  if (loadingPlayer) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 400 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!playerProfile?.id) {
    return (
      <Container maxWidth="lg" sx={{ mt: 4 }}>
        <Alert severity="info">
          Player profile not found for this coach account. Complete a Training Evaluation or Learn and Rank session to establish your player profile.
        </Alert>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <PlayerCertificates player={playerProfile} />
    </Container>
  );
};

export default CoachCertificatesPage;
